module.exports = __webpack_public_path__ + "img/Flowscape.432bbc87.png";